import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './plugins/vuetify';
import './plugins/vuelidate';
import './plugins/google_maps';
import './plugins/v_currency';
import './plugins/vue-observe-visibility';
import './plugins/vue-cookies';
import './plugins/vue-beautiful-chat';
import vuetify from './plugins/vuetify';



import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2VVhhQlFacldJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkFiWn9ccHxRQmZbVkM=');

import loadingDialog from '@/plugins/loadingDialog'
Vue.use(loadingDialog)

import snackbar from './plugins/snackbar'
Vue.use(snackbar)
import colorsConfig from './plugins/colors-config'
Vue.use(colorsConfig)

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);



Vue.config.productionTip = false;

const app = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");

window.App = app
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title && !isNaN(to.meta.title)) {
    document.title = + to.meta.title + " - MRC Dispatch";
  } else {
    document.title = "MRC Dispatch";
  }
  next();
});

function generateSitemap() {
  const baseUrl = 'http://dispatch.myridecompany.co.uk'
  let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">`

  const routes = router.options.routes
  for (const route of routes) {
    sitemap += `
        <url>
            <loc>${baseUrl}${route.path}</loc>
        </url>`
    if (route.children) {
      for(const child of route.children) {
        sitemap += `
                <url>
                    <loc>${baseUrl}${route.path}${child.path}</loc>
                </url>`
      }
    }
  }
  sitemap += '</urlset>'
  return sitemap
}

// console.log(generateSitemap())